<template>
  <div class="course-notification">
    <div v-if="sharing" class="inline-page" />
    <weui-msg type="warn" :primary="true" title="课程设置成功，但未能通知会员" :desc="`由于会员${course.user_name}仍然没有和您绑定，所设定的课程无法自动通知他`">
      <weui-button type="primary" @click="notify">微信发通知</weui-button>
      <weui-button type="default" @click="notify">微信发绑定</weui-button>
      <weui-button type="default" @click="goback">返回列表</weui-button>
    </weui-msg>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiMsg, WeuiButton } from '@/components/weui';

import { FETCH_COURSE, NOTIFY_COURSE } from '@/store/course/types';
import { SHARE_COURSE } from '@/store/share/types';

const { mapState: mapCourseState, mapActions: mapCourseActions } = createNamespacedHelpers('course');
const { mapState: mapShareState, mapActions: mapShareActions } = createNamespacedHelpers('share');

export default {
    data() {
        return {
            id: 0,
            sharing: false,
        };
    },
    computed: {
        ...mapCourseState({
            course: state => state.course || {},
        }),
        ...mapShareState({
            share: state => state.share || {},
        }),
    },
    created() {
        const id = Number.parseInt(this.$route.params.id, 10);
        this.id = id;

        this.fetchCourse({ id });
    },
    methods: {
        ...mapCourseActions({
            fetchCourse: FETCH_COURSE,
            notifyCourse: NOTIFY_COURSE,
        }),
        ...mapShareActions({
            shareCourse: SHARE_COURSE,
        }),
        async notify() {
            this.sharing = true;
            await this.shareCourse({ id: this.id });
            if (await this.$wechat.shareAppMessage(this.share)) {
                this.notifyCourse({ id: this.id });
            }
            this.sharing = false;
        },
        goback() {
            this.$router.go(-1);
        },
    },
    components: {
        WeuiMsg,
        WeuiButton,
    },
};
</script>

<style lang="scss" scoped>
.inline-page {
    background: rgba(0, 0, 0, 0.85) url(../../assets/images/share-course.png) no-repeat;
    background-size: contain;
    z-index: 1010;
}
</style>



// WEBPACK FOOTER //
// src/containers/course/Notification.vue